export default __webpack_public_path__ + "static/media/cesto.b305998d.png";